import classes from './SwitchToggleFourOption.module.css'
import { SwitchToggleFourOptionEnum } from '../../models/SwitchToggleFourOptionEnum'

const SwitchToggleFourOption = ({ status, onChangeStatus }) => {
    const styleOption = {
        [SwitchToggleFourOptionEnum.Correct]: { bg: "#73DED8", position: "5%", color: "#FFFFFF" },
        [SwitchToggleFourOptionEnum.InCorrect]: { bg: "#ED8068", position: "55%", color: "#FFFFFF" },
        [SwitchToggleFourOptionEnum.NotChecked]: { bg: "#D9D9D9", position: "30%", color: "#FFFFFF" },
        [SwitchToggleFourOptionEnum.Disabled]: { bg: "#D9D9D9", position: "30%", color: "#C4C4C4" }
    }

    const HandeleChangeStatus = () => {
        if (status != SwitchToggleFourOptionEnum.Disabled) {
            if (status == SwitchToggleFourOptionEnum.Correct) {
                onChangeStatus(SwitchToggleFourOptionEnum.InCorrect)
            }
            else if (SwitchToggleFourOptionEnum.InCorrect)
                onChangeStatus(SwitchToggleFourOptionEnum.Correct)
        }
    }

    return (
        <>
            {status && <div className={classes.SwitchToggleContainer} onClick={() => HandeleChangeStatus()} style={{ backgroundColor: `${styleOption[status].bg}` }}>
                <div className={classes.SwitchBtn} style={{ insetInlineStart: `${styleOption[status].position}`, backgroundColor: `${styleOption[status].color}` }}></div>
                {status == SwitchToggleFourOptionEnum.NotChecked &&
                    <div>
                        <div className={classes.CorrectAnswer} onClick={() => onChangeStatus(SwitchToggleFourOptionEnum.Correct)}> </div>
                    </div>
                }
            </div>}
        </>
    )

}
export default SwitchToggleFourOption